// removed by extract-text-webpack-plugin
module.exports = {"banner-container":"banner-container__kMFaA","banner-wrapper":"banner-wrapper__2u6rn","banner-leftcontent":"banner-leftcontent__2ooKl","banner-leftcontent-title":"banner-leftcontent-title__26OAV","formContainer":"formContainer__7aWHi","banner-emailInput":"banner-emailInput__364ke","banner-captchacontainer":"banner-captchacontainer__1TOuM","customCaptch":"customCaptch__wDAMu","submitBtnSuccessful":"submitBtnSuccessful__2GAk5","banner-img":"banner-img__2uNS6"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/banner/Banner.scss
// module id = 1137
// module chunks = 68